import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { EloquaCopySource } from 'app/model/pipeline/copysource/eloqua.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EloquaCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class EloquaCopySourceAdapter extends CopySourceAdapter<EloquaCopySource, Model.EloquaSource> {
    protected override async _toResource(copySource: EloquaCopySource): Promise<Model.EloquaSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(EloquaCopySource).name);
    }

    protected override async _toModel(
        resource: Model.EloquaSource,
        copyActivity: CopyActivity
    ): Promise<EloquaCopySource> {
        return this._toTabularModel(resource, copyActivity, EloquaCopySource.MODEL);
    }
}
